module.exports = __webpack_public_path__ + "assets/c4ebe99859b6c5a230165fdb5302deab.png";